export const sizeInPx = (size, sizeViewBox, sizePx = 1) => size * (sizeViewBox / sizePx);
